module.exports = __webpack_public_path__ + "img/Portal-CheckInicons-sick.c7456a24.png";